export const SERVICE_ALERT_COUNT_QUERY_KEY = ["admin", "services", "alert-count"];

export async function syncServiceAlertCount(queryClient, summary) {
  const count = summary.alerts.warning + summary.alerts.critical;

  // An older badge request must not overwrite the freshly loaded page status.
  await queryClient.cancelQueries({
    queryKey: SERVICE_ALERT_COUNT_QUERY_KEY,
    exact: true,
  });
  queryClient.setQueryData(SERVICE_ALERT_COUNT_QUERY_KEY, {
    success: true,
    count,
  });
}
